import { Pipe, PipeTransform } from '@angular/core';
import { Fremdsystem } from '../../components/fremdsysteme/fremdsysteme.component';

@Pipe({
  name: 'fremdsystemVisibility'
})
export class FremdsystemVisibilityFilterPipe implements PipeTransform {
  transform(fremdsysteme: Fremdsystem[]): Fremdsystem[] {
    if (!fremdsysteme) {
      return fremdsysteme;
    }
    return fremdsysteme.filter((fremdsystem) => fremdsystem.isVisible);
  }
}
